import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --william-column-gap: calc(24rem / var(--default-rem-px-count));
      --william-heading-block: calc(24rem / var(--default-rem-px-count));
      --william-entry-gap: calc(30rem / var(--default-rem-px-count));
      --william-entry-label-gap: calc(2rem / var(--default-rem-px-count));
    }

    .william-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .william-body {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      gap: var(--william-heading-block);
      color: var(--block-text-color, #222);
    }

    .william-heading {
      font-weight: var(--fw-medium);
      font-size: var(--fs-label-small);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
      margin: 0;
    }

    /* Mobile: 2 columns of entries */
    .william-entries {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      column-gap: var(--william-column-gap);
      align-items: start;
    }

    .william-column {
      display: flex;
      flex-direction: column;
      gap: var(--william-entry-gap);
      min-width: 0;
    }

    .william-entry {
      display: flex;
      flex-direction: column;
      gap: var(--william-entry-label-gap);
      min-width: 0;
    }

    .william-entry-label {
      font-weight: var(--fw-medium);
      font-size: var(--fs-label-small);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
      margin: 0;
      color: var(--block-text-color, #222);
    }

    .william-entry-value {
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
      color: var(--block-text-color, #222);
    }

    /* Match both <p> (legacy editor input) and <div> (Trix output). */
    .william-entry-value p,
    .william-entry-value div {
      margin: 0;
      font-size: inherit;
      line-height: inherit;
      letter-spacing: inherit;
    }

    /* Tablet: 3-column grid */
    @media (min-width: 600px) {
      :host {
        --william-column-gap: calc(32rem / var(--default-rem-px-count));
      }

      .william-body {
        grid-column: 2 / 14;
      }

      .william-entries {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }
    }

    /* Desktop: the heading label sits on the left as its own column,
       then the entries spread evenly across the remaining columns. */
    @media (min-width: 1024px) {
      :host {
        --william-column-gap: calc(40rem / var(--default-rem-px-count));
      }

      .william-body {
        display: grid;
        grid-template-columns:
          calc(201rem / var(--default-rem-px-count))
          minmax(0, 1fr);
        column-gap: var(--william-column-gap);
        align-items: start;
      }

      .william-heading {
        grid-column: 1;
        grid-row: 1;
      }

      .william-entries {
        grid-column: 2;
        grid-row: 1;
        grid-template-columns: repeat(5, minmax(0, 1fr));
      }
    }
  `,
];
